import styled from 'styled-components'

import Heading from 'components/Heading'
import PaymentLogo from 'components/PaymentLogo'
import { Title } from 'components/IndexLayout'

import { breakpoint } from 'utils'

export const Wrapper = styled.div`
  margin: auto;

  ${Title} {
    margin-top: 32px;
  }
`

export const Layout = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  position: relative;
  z-index: 1;

  width: 100%;
  flex-grow: 1;
`

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 550px;

  ${breakpoint('md')`
      width: 472px;
  `}
`

export const SummaryWrapper = styled.div`
  width: 100%;

  position: fixed;
  bottom: 0;

  ${breakpoint('sm', 'md')`
    max-width: 550px;
  `}

  ${breakpoint('md')`
    position: sticky;
      bottom: 0px;
      top: 60px;
      align-self: self-start;
      width: 360px;
      margin-left: 80px;
  `}
`

export const ButtonWrapper = styled.div`
  ${breakpoint('base', 'md')`
      position: fixed;
      bottom: 0px;
      left: 0;
      right: 0;

      width: 100%;
      max-width: 550px;
      z-index: 1;
      margin: auto;
      padding: 24px;
  `}
`

export const SubHeading = styled(Heading.H2)`
  line-height: 1;
  margin-top: 0;
  margin-bottom: 7px; /* stylelint-disable-line scales/space */
`

export const CreditCardWrapper = styled.div`
  flex-direction: column;
`

export const CreditCardLogo = styled(PaymentLogo)`
  margin-right: 8px;
`
